import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { syncApi } from '../api/syncApi';

const SyncStatusContext = createContext(null);

export const useSyncStatus = () => {
  const context = useContext(SyncStatusContext);
  if (!context) {
    throw new Error('useSyncStatus must be used within SyncStatusProvider');
  }
  return context;
};

export const SyncStatusProvider = ({ children }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  const refreshSyncStatus = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await syncApi.getStatus();
      setStatus(data);
      return data;
    } catch (e) {
      setError(e.message || '同期状態の取得に失敗しました');
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshSyncStatus().catch(() => {
      // エラーは state に保持。未ログイン等は client.js がリダイレクト処理。
    });
  }, [location.pathname, refreshSyncStatus]);

  return (
    <SyncStatusContext.Provider value={{ status, loading, error, refreshSyncStatus }}>
      {children}
    </SyncStatusContext.Provider>
  );
};
